import React, { useContext, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import _ from "lodash";
import LanguageContext from "../LanguageContext";
import { useHistory, useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundry";
import RecordedClassPlayer from "./RecordedClassPlayer";
import firebase from "../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "black",
    color: "white",
    paddingTop: theme.spacing(2),
  },
  closeButton: {
    color: "white",
    marginBottom: theme.spacing(1),
  },
  videoTitle: {
    marginLeft: theme.spacing(2),
  },
}));

export default function VideoDialog(props) {
  const theme = useTheme();
  const language = useContext(LanguageContext);
  const [videoPlayerConfig, setVideoPlayerConfig] = useState({});
  let history = useHistory();
  const location = useLocation();
  const handleClose = () => {
    history.goBack();
  };

  const handlePlaybackStart = () => {
    if (location && location.state && location.state.recordedMeeting) {
      let recordedMeeting = location.state.recordedMeeting;
      firebase.analytics().logEvent("recorded_class_playback_started", {
        mobile: props.mobile,
        position: props.position,
        user_type: props.userType,
        farmer_crops: JSON.stringify(props.farmerCrops),
        user_source: props.userSource,
        session_topic: recordedMeeting.sessionTopic,
        week: recordedMeeting.week,
        sessionType: recordedMeeting.sessionType,
        crop_name: recordedMeeting.crop?.name_en,
        author_name: recordedMeeting.author?.name_en,
        state: recordedMeeting.state?.[0]?.name_en,
        class_start_time: recordedMeeting.startTime,
      });
    } else {
    }
  };

  const handlePlaybackEnd = () => {
    if (location && location.state && location.state.recordedMeeting) {
      let recordedMeeting = location.state.recordedMeeting;
      firebase.analytics().logEvent("recorded_class_playback_ended", {
        mobile: props.mobile,
        position: props.position,
        user_type: props.userType,
        farmer_crops: JSON.stringify(props.farmerCrops),
        user_source: props.userSource,
        session_topic: recordedMeeting.sessionTopic,
        week: recordedMeeting.week,
        sessionType: recordedMeeting.sessionType,
        crop_name: recordedMeeting.crop?.name_en,
        author_name: recordedMeeting.author?.name_en,
        state: recordedMeeting.state?.[0]?.name_en,
        class_start_time: recordedMeeting.startTime,
      });
    } else {
    }
  };

  const handlePlaybackProgress = (currentTime) => {
    if (location && location.state && location.state.recordedMeeting) {
      let recordedMeeting = location.state.recordedMeeting;
      firebase.analytics().logEvent("recording_watched", {
        mobile: props.mobile,
        duration: 60,
        current_time: currentTime,
        position: props.position,
        user_type: props.userType,
        farmer_crops: JSON.stringify(props.farmerCrops),
        user_source: props.userSource,
        session_topic: recordedMeeting.sessionTopic,
        week: recordedMeeting.week,
        sessionType: recordedMeeting.sessionType,
        crop_name: recordedMeeting.crop?.name_en,
        author_name: recordedMeeting.author?.name_en,
        state: recordedMeeting.state?.[0]?.name_en,
        class_start_time: recordedMeeting.startTime,
      });
    } else {
    }
  };

  useEffect(() => {
    if (
      location.state.recordedMeeting &&
      location.state.recordedMeeting.video
    ) {
      let recordedMeeting = location.state.recordedMeeting;

      setVideoPlayerConfig({
        sources: [
          {
            src: `${recordedMeeting.video.download_url}?access_token=${location.state.jwtToken}`,
            type: "video/mp4",
          },
        ],
      });
    }
  }, [location.state]);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ErrorBoundary page={"recorded-video-page"} section={"entire-page"}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={1} sm={1}></Grid>
          <Grid item xs={9} sm={9}>
            <Typography
              variant={"h6"}
              gutterBottom
              className={classes.videoTitle}
            >
              {location.state.recordedMeeting.cropName} -
              {location.state.recordedMeeting.shortDescription}
            </Typography>
          </Grid>

          <Grid item xs={2} sm={1}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleClose}
              size="large">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid xs={12} sm={10} item>
            {videoPlayerConfig && !_.isEmpty(videoPlayerConfig) && (
              <RecordedClassPlayer
                handlePlaybackProgress={handlePlaybackProgress}
                handlePlaybackStart={handlePlaybackStart}
                handlePlaybackEnd={handlePlaybackEnd}
                autoplay={true}
                sources={videoPlayerConfig.sources}
              />
            )}
          </Grid>
        </Grid>
      </ErrorBoundary>
    </div>
  );
}
